import api from "../../../context-module/context-configuration/auth-provider/apiGroup/api";

const ApiPost = <T = unknown>(
  url: string,
  data?: unknown,
  responseType: "json" | "blob" = "json"
) => {
  return api.post<T>(url, data,{ responseType });
};

export default ApiPost;
